import React, { createContext, useContext, useRef } from 'react';

export interface NotificationNavTarget {
  organization_id: string;
  project_id?: string;
  project_name?: string;
  task_id?: string; // when present, opens the Daily Log task detail
}

interface NotificationContextType {
  // Registered once by App.tsx, which owns org-switch / project-select / module-select state.
  setNavigateHandler: (fn: (target: NotificationNavTarget) => void) => void;
  navigate: (target: NotificationNavTarget) => void;
}

const NotificationContext = createContext<NotificationContextType>({
  setNavigateHandler: () => {},
  navigate: () => {},
});

export const NotificationProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const handlerRef = useRef<((target: NotificationNavTarget) => void) | null>(null);

  const setNavigateHandler = (fn: (target: NotificationNavTarget) => void) => {
    handlerRef.current = fn;
  };

  const navigate = (target: NotificationNavTarget) => {
    handlerRef.current?.(target);
  };

  return (
    <NotificationContext.Provider value={{ setNavigateHandler, navigate }}>
      {children}
    </NotificationContext.Provider>
  );
};

export const useNotificationNav = () => useContext(NotificationContext);
